export enum Role {
  Admin = 'admin',
  Anyone = 'anyone',
  HeadOfSpecialisation = 'headOfSpecialisation',
  DepartmentAdministrator = 'departmentAdministrator',
  SubjectResponsibleTeacher = 'subjectResponsibleTeacher',
  Employee = 'employee',
}
